module.exports = [
    'as'
  , 'because'
  , 'for'
  , 'and'
  , 'nor'
  , 'but'
  , 'or'
  , 'yet'
  , 'so'
]



//////////////////
// WEBPACK FOOTER
// ./node_modules/titlecase/conjunctions.js
// module id = 1465
// module chunks = 1 2